module.exports = __webpack_public_path__ + "static/media/brand-refresh-FacebookLogo.ac6275e1.svg";